import React, { FC } from 'react';
import { Modal } from 'antd';
import { colors } from 'styles/colors';
import { Text } from 'components/text/Text';
import styled from 'styled-components';
import { VideoPlayer } from 'components/video/VideoPlayer';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { CHECK_PRIMARY_ICON } from 'assets/icons/icons';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { fontSize } from 'styles/theme';
import { ActionButton } from 'src/pages-all/home/components/ActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { AppRoute } from 'app/app.route.const';
import { useExitIntent } from 'logic/hooks/use-exitIntent';
import { getAuthenticatedUser } from 'logic/store/authentication/authentication.selectors';

const Header = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 0 auto 20px auto;
  padding: 20px 0;
  background-color: ${colors.gray13};
  border-bottom: 1px solid ${colors.black};
  border-radius: 10px 10px 0 0;
`;

const Headline = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 20px 0;
`;

const ContentItem = styled.div`
  margin: auto 0 auto 20px;
`;

const FooterContent = styled.div`
  display: flex;
  flex: 1;
  margin: 12px 0 24px 0;
`;

const BulletpointItemTop = styled.span`
  font-size: ${fontSize.lg};
  color: ${colors.primary};
  font-weight: 600;
  padding: 9px 0 6px 9px;
  display: block;
`;

export const ExitIntentModal: FC<{
  actionUrl?: string;
}> = ({ actionUrl = AppRoute.Home }) => {
  const { onExit, setOnExit } = useExitIntent();
  const user = useSelector(getAuthenticatedUser);
  const dispatch = useDispatch();
  if (user) return null;

  return (
    <Modal
      title=""
      bodyStyle={{ padding: 0 }}
      visible={onExit}
      footer={null}
      onCancel={() => setOnExit(false)}
      width={1100}
    >
      <Header>
        <Text size={38} color={'black'} fontWeight={800}>
          {translate(translationKeys.exitIntentModal.headline)}
        </Text>
      </Header>
      <Headline>
        <Text size={34} color={'black'} fontWeight={700} textAlign={'center'}>
          {translate(translationKeys.exitIntentModal.subheadline)}
        </Text>
      </Headline>
      <Content>
        <ContentItem>
          <VideoPlayer id={'560349981'} ratio={0.56} style={{ width: 500, height: 300 }} />
        </ContentItem>
        <ContentItem>
          {Object.entries(translationKeys.exitIntentModal.content.bulletpoints).map(
            ([translationKey, translationValue]) => (
              <BulletpointItemTop key={translationKey}>
                <CustomIcon
                  src={CHECK_PRIMARY_ICON}
                  width={20}
                  style={{ paddingRight: '4px', fill: colors.primary }}
                />{' '}
                {translate(translationValue)}
              </BulletpointItemTop>
            )
          )}
        </ContentItem>
      </Content>
      <FooterContent>
        <ActionButton
          style={{ margin: '24px auto', fontWeight: 600 }}
          onClick={() => dispatch(navigationSlice.actions.navigateTo({ path: actionUrl }))}
        >
          {translate(translationKeys.exitIntentModal.button)}
        </ActionButton>
      </FooterContent>
    </Modal>
  );
};
